import React, { useState } from 'react';
import { Tabs, TabsList, TabsTrigger } from '../ui/tabs';
import { Navbar } from '../Layout/Navbar';
import { Sidebar } from '../Layout/Sidebar';
import { OrderPanel } from '../Orders/OrderPanel';
import { POSPage } from '../../pages/POSPage';
import { TablesPage } from '../../pages/TablesPage';
import { CustomersPage } from '../../pages/CustomersPage';
import { ProductsPage } from '../../pages/ProductsPage';
import { PaymentModal } from '../ui/PaymentModal';
import { TipsModal } from '../ui/TipsModal';
import { useOrders } from '../../hooks/useOrders';
import { useProducts } from '../../hooks/useProducts';
import { getVentaData, setVentaData } from '../../utils/ventaTemp';
import { enviarVentaYPropina } from '../../services/api';
import TicketPrinter from '../TicketPrinter'; // ajustá la ruta si es distinta
import { Button } from '../ui/button'; // ajustá la ruta según tu estructura
import API_BASE_URL from '../../Config';


function useMobileDetect() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [showPropinaPregunta, setShowPropinaPregunta] = useState(false);
  const [paymentSuccess, setPaymentSuccess] = useState(false);


  React.useEffect(() => {
    const handleResize = () => {
      const isMobileView = window.innerWidth < 768;
      setIsMobile(isMobileView);
      if (!isMobileView) {
        setIsMobileMenuOpen(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(prev => !prev);
  };

  return {
    isMobile,
    isMobileMenuOpen,
    toggleMobileMenu,
    setIsMobileMenuOpen,
  };
}

export function MainPOSLayout() {
  const { isMobile, isMobileMenuOpen, toggleMobileMenu, setIsMobileMenuOpen } = useMobileDetect();

  const {
    activeOrders,
    currentOrder,
    showOrderPanel,
    setShowOrderPanel,
    closeOrder,
    ...orderActions
  } = useOrders();

  const {
    products,
    filteredProducts,
    categories,
    paymentMethod,
    setPaymentMethod,
    showPaymentModal,
    setShowPaymentModal,
    processPayment,
    isProcessingPayment,
    selectedCategory,
    searchTerm,
    setSelectedCategory,
    setSearchTerm,
    
    cart,
    clearCart,
    ...productActions
  } = useProducts();

  const [activeTab, setActiveTab] = useState('pos');
  const [showTipsModal, setShowTipsModal] = useState(false);
  const [mostrarTicket, setMostrarTicket] = useState(false);
const [idUltimaVenta, setIdUltimaVenta] = useState(null);


  const handleTabChange = (tab) => {
    setActiveTab(tab);
    if (isMobile) {
      setIsMobileMenuOpen(false);
    }
  };

  const handleCloseSidebar = () => {
    setIsMobileMenuOpen(false);
  };

  const handleCloseOrderPanel = () => {
    setShowOrderPanel(false);
  };

  const cartTotal = currentOrder
    ? currentOrder.items.reduce((sum, item) => sum + (item.price * item.quantity), 0)
    : 0;


  //buscar productos
    const buscarProductosDesdeBack = async (termino) => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/productos/productos/buscar?query=${termino}`);
      const data = await response.json();

      // Normaliza los productos si es necesario
      const normalizados = data.map(p => ({
        id: p.id,
        name: p.nombre,
        price: p.precio,
        category: p.categoria?.nombre || 'Sin categoría',
      }));

      productActions.setProducts(normalizados); // 👈 usa el setter de useProducts
    } catch (error) {
      console.error('Error al buscar productos:', error);
    }
  };






  //Alexis= se cambio el cod de abajo por este=
const handlePaymentSuccess = ({ deseaDejarPropina, tip, mozo } = {}) => {
  if (deseaDejarPropina && tip && mozo) {
    // ✅ Ya tenemos los datos, entonces guardar aquí
    const ventaTemp = getVentaData();

    const ventaFinal = {
      ...ventaTemp,
      propina: Number(tip || 0),
      mozo,
      total: (ventaTemp.total || 0) + Number(tip || 0)
    };

    enviarVentaYPropina(ventaFinal).then(res => {
      if (res?.id) {
        setIdUltimaVenta(res.id);
        setMostrarTicket(true);
      }
    });

    clearCart();
    closeOrder(currentOrder.id);
    setShowOrderPanel(false);
  } else {
    // Caso sin propina
    const ventaTemp = getVentaData();
    enviarVentaYPropina(ventaTemp).then(res => {
      if (res?.id) {
        setIdUltimaVenta(res.id);
        setMostrarTicket(true);
      }
    });

    clearCart();
    closeOrder(currentOrder.id);
    setShowOrderPanel(false);
  }
};


  
  
  {/*const handlePaymentSuccess = ({ deseaDejarPropina } = {}) => {
    if (currentOrder) {
      if (deseaDejarPropina) {
        setShowTipsModal(true);
      } else {
const previo = getVentaData();
setVentaData({
  ...previo,
  mesa: currentOrder.name,
  productos: currentOrder.items.map(item => ({
    id: item.productId,
    nombre: item.productName,
    precio: item.price,
    cantidad: item.quantity,
  })),
  total: cartTotal,
  propina: 0,
  mozo: null,
});


        const venta = getVentaData();
        enviarVentaYPropina(venta);
        clearCart();
        closeOrder(currentOrder.id);
        setShowOrderPanel(false);
      }
    }
  };*/}
  ///

  const handleTipsConfirm = ({ tip, mozo }) => {
    if (!currentOrder || !Array.isArray(currentOrder.items)) return;

    const propina = Number(tip || 0);
    const totalBase = currentOrder.items.reduce((sum, item) => sum + item.price * item.quantity, 0);
    const totalConPropina = totalBase + propina;

    setVentaData({
      mesa: currentOrder.name,
      productos: currentOrder.items.map(item => ({
        id: item.productId,
        nombre: item.productName,
        precio: item.price,
        cantidad: item.quantity,
      })),
      total: totalConPropina,
      propina: propina,
      mozo: mozo,
    });

    const venta = getVentaData();
    enviarVentaYPropina(venta);
    clearCart();
    closeOrder(currentOrder.id);
    setShowOrderPanel(false);
  };


  //Alexis
  const iniciarPago = () => {
  if (!currentOrder || !currentOrder.items) return;

  const ventaData = {
    productos: currentOrder.items,
    total: cartTotal,
    tipoOrden: currentOrder.type,
    nombreOrden: currentOrder.name,
  };

  setVentaData(ventaData);
  processPayment(); // Esta abre el PaymentModal
};








  return (
    <div className="min-h-screen bg-gray-100">
      <Navbar isMobileMenuOpen={isMobileMenuOpen} toggleMobileMenu={toggleMobileMenu} />
      <Sidebar
        isOpen={isMobileMenuOpen}
        activeTab={activeTab}
        onTabChange={handleTabChange}
        onClose={handleCloseSidebar}
      />

      <main className="p-4">
        <Tabs value={activeTab} onValueChange={handleTabChange}>
          <TabsList className="w-full justify-start mb-4 md:flex hidden">
            <TabsTrigger value="pos">POS</TabsTrigger>
            <TabsTrigger value="tables">Mesas</TabsTrigger>
            <TabsTrigger value="customers">Clientes</TabsTrigger>
            {/*<TabsTrigger value="products">Productos</TabsTrigger>*/}
          </TabsList>

          <div className="md:mr-96">
            {activeTab === 'pos' && (
              <POSPage
                products={products}
                filteredProducts={filteredProducts}
                categories={categories}
                currentOrder={currentOrder}
                activeOrders={activeOrders}
                setSelectedCategory={setSelectedCategory}
                setSearchTerm={setSearchTerm} // 👈 este
                buscarProductosDesdeBack={buscarProductosDesdeBack} // 👈 AGREGAR
                //Alexis
                iniciarPago={iniciarPago}


                {...productActions}
                {...orderActions}
              />
            )}
            {activeTab === 'tables' && (
              <TablesPage activeOrders={activeOrders} {...orderActions} />
            )}
            {activeTab === 'customers' && (
              <CustomersPage activeOrders={activeOrders} {...orderActions} />
            )}
            {activeTab === 'products' && (
              <ProductsPage
                products={products}
                categories={categories}
                paymentMethod={paymentMethod}
                setPaymentMethod={setPaymentMethod}
                showPaymentModal={showPaymentModal}
                setShowPaymentModal={setShowPaymentModal}
                processPayment={processPayment}
                isProcessingPayment={isProcessingPayment}
                selectedCategory={selectedCategory}
                searchTerm={searchTerm}
                setSelectedCategory={setSelectedCategory}
                setSearchTerm={setSearchTerm}
                {...productActions}
              />
            )}
          </div>
        </Tabs>

        {currentOrder && (
          <OrderPanel
            order={currentOrder}
            showOrderPanel={showOrderPanel}
            onClose={handleCloseOrderPanel}
            setShowPaymentModal={setShowPaymentModal}
            {...orderActions}
          />
        )}
      </main>

      {showPaymentModal && (
        <PaymentModal
  showPaymentModal={showPaymentModal}
  setShowPaymentModal={setShowPaymentModal}
  paymentMethod={paymentMethod}
  setPaymentMethod={setPaymentMethod}
  totalAmount={cartTotal}
  currentOrder={currentOrder}
  onPaymentSuccess={handlePaymentSuccess}
  processPayment={iniciarPago}
  isProcessingPayment={isProcessingPayment}
  // NUEVOS
  setMostrarTicket={setMostrarTicket}
  setIdUltimaVenta={setIdUltimaVenta}
        />
      )}

      {showTipsModal && (
        <TipsModal
          showTipsModal={showTipsModal}
          setShowTipsModal={setShowTipsModal}
          totalAmount={cartTotal}
          currentOrder={currentOrder}
          onConfirm={handleTipsConfirm}
        />
      )}
{mostrarTicket && (
  <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
    <div className="bg-white p-4 rounded-lg shadow-lg max-w-lg w-full relative">
      <TicketPrinter ventaId={idUltimaVenta} />
      <div className="flex justify-end gap-4 mt-4">
        <Button
          className="bg-blue-600 text-white"
          onClick={() => {
            window.print();
            clearCart();               // ✅ limpiar carrito
            setMostrarTicket(false);  // ✅ cerrar modal
            if (currentOrder) {
              closeOrder(currentOrder.id); // ✅ cerrar orden si hay una activa
              setShowOrderPanel(false);    // ✅ cerrar panel de orden
            }
          }}
        >
          Imprimir Ticket
        </Button>
        <Button
          variant="outline"
          onClick={() => {
            clearCart();
            setMostrarTicket(false);
            if (currentOrder) {
              closeOrder(currentOrder.id);
              setShowOrderPanel(false);
            }
          }}
        >
          Cerrar
        </Button>
      </div>
    </div>
  </div>
)}



    </div>
  );
}

export default MainPOSLayout;